import React, { useState, useEffect } from "react";
import TextEditor from "../components/TextEditor.jsx";
import "../static/css/AdminPublications.css";

const AdminPublications = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [date, setDate] = useState("");
  const [publicationContent, setPublicationContent] = useState("");
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [newCategoryImage, setNewCategoryImage] = useState(null);
  const [newCategoryDescription, setNewCategoryDescription] = useState("");
  const [publications, setPublications] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://skpbackend.quindl.com/categories");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
    fetchPublications();
  }, []);

  const fetchPublications = async () => {
    try {
      const response = await fetch("https://skpbackend.quindl.com/publications");
      const data = await response.json();
      setPublications(data);
    } catch (error) {
      console.error("Error fetching publications:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this publication?")) {
      try {
        const response = await fetch(`https://skpbackend.quindl.com/publications/delete/${id}`, {
          method: "DELETE",
        });
        if (response.ok) {
          alert("Publication deleted successfully");
          fetchPublications();
        } else {
          alert("Failed to delete publication");
        }
      } catch (error) {
        console.error("Error deleting publication:", error);
      }
    }
  };

  const handleEdit = (pub) => {
    setIsEditing(true);
    setEditId(pub.id);
    setTitle(pub.title || "");
    setDescription(pub.description || "");
    setCategoryId(pub.category_id || "");
    
    // Handle date formatting correctly
    if (pub.date) {
        const d = new Date(pub.date);
        if (!isNaN(d.getTime())) {
            setDate(d.toISOString().split("T")[0]);
        } else {
            setDate("");
        }
    } else {
        setDate("");
    }
    
    setPublicationContent(pub.content || "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setDate("");
    setCategoryId("");
    setPublicationContent("");
    setIsEditing(false);
    setEditId(null);
  };

  const handleAddCategory = async () => {
    if (newCategory) {
      const categoryData = {
        name: newCategory,
        description: newCategoryDescription,
        image: newCategoryImage,
      };

      try {
        const response = await fetch("https://skpbackend.quindl.com/categories/add", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(categoryData),
        });

        if (response.ok) {
          const result = await response.json();
          alert("Category added successfully!");
          console.log(result);

          setNewCategory("");
          setNewCategoryImage(null);
          setNewCategoryDescription("");
          setCategories([...categories, result]);
        } else {
          alert("Failed to add category.");
        }
      } catch (error) {
        console.error("Error adding category:", error);
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewCategoryImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (!title || !categoryId) {
        alert("Please fill in Title and Category.");
        return;
    }

    const publicationData = {
      title,
      description,
      date,
      category_id: categoryId,
      content: publicationContent,
    };

    const url = isEditing
      ? `https://skpbackend.quindl.com/publications/update/${editId}`
      : "https://skpbackend.quindl.com/publications/add";
    const method = isEditing ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(publicationData),
      });

      if (response.ok) {
        alert(`Publication ${isEditing ? "updated" : "posted"} successfully!`);
        resetForm();
        fetchPublications(); // Refresh list
      } else {
        const errorMsg = await response.text();
        alert(`Failed to ${isEditing ? "update" : "post"} publication: ${errorMsg}`);
      }
    } catch (error) {
      console.error(`Error ${isEditing ? "updating" : "posting"} publication:`, error);
    }
  };

  return (
    <div className="admin-container">
      <div className="pub-content">
        <input
          type="text"
          placeholder="Article Title"
          className="article-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <textarea
          placeholder="Article Description"
          className="article-description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <select
          className="dropdown"
          value={categoryId}
          onChange={(e) => setCategoryId(e.target.value)}
        >
          <option value="">Select Category</option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>

        <div className="editor">
          <TextEditor
            content={publicationContent}
            setContent={setPublicationContent}
          />
        </div>

        <input
          type="date"
          className="publication-date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <button className="post-button" onClick={handleSubmit}>
          {isEditing ? "UPDATE Blog" : "POST Blog"}
        </button>
        {isEditing && (
          <button 
            className="post-button" 
            onClick={resetForm} 
            style={{ marginTop: '10px', background: '#888' }}
          >
            Cancel Edit
          </button>
        )}

        <div className="existing-publications" style={{ marginTop: '40px', borderTop: '1px solid #ddd', paddingTop: '20px' }}>
            <h3>Existing Publications</h3>
            <div className="publication-list" style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
                {publications.map((pub) => (
                    <div key={pub.id} className="publication-item">
                        <h4 style={{ margin: '0 0 10px 0', color: '#009688' }}>{pub.title}</h4>
                        <p style={{ fontSize: '0.85em', color: '#888', margin: '0 0 10px 0' }}>
                          {pub.date ? new Date(pub.date).toLocaleDateString() : 'No Date'}
                        </p>
                        <p style={{ fontSize: '0.9em', color: '#555', marginBottom: '15px' }}>{pub.description}</p>
                        <div className="item-actions">
                          <button 
                            className="edit-btn"
                            onClick={() => handleEdit(pub)}
                          >
                            Edit
                          </button>
                          <button 
                            className="delete-btn"
                            onClick={() => handleDelete(pub.id)}
                          >
                            Delete
                          </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
      </div>

      <div className="sidebar">
        <div className="add-category">
          <h4>Add a new category</h4>
          <input
            type="text"
            placeholder="Enter new category"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
          />
          <textarea
            placeholder="Enter category description"
            value={newCategoryDescription}
            onChange={(e) => setNewCategoryDescription(e.target.value)}
          />
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="category-image-upload"
          />
          {newCategoryImage && (
            <img
              src={newCategoryImage}
              alt="New Category Preview"
              className="category-image-preview"
            />
          )}
          <button className="add-button" onClick={handleAddCategory}>
            ADD CATEGORY
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPublications;
